import { useQuery } from "@tanstack/react-query";
import { membershipApi } from "@bw/shared/api";
import { useAuth } from "@bw/shared/hooks";
import type { SubscriptionResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * A single subscription the caller owns (GET /memberships/{id} → enriched
 * SubscriptionResponse). The backend returns 404 for both not-found AND
 * not-owner (no enumeration oracle), so the detail page treats an error as
 * "can't load this membership". Authenticated, UID-scoped and freshly revalidated.
 */
export function useSubscription(subscriptionId: string | undefined) {
  const { user } = useAuth();
  return useQuery<SubscriptionResponse>({
    queryKey: [...queryKeys.memberships.detail(subscriptionId ?? ""), user?.uid],
    queryFn: ({ signal }) => membershipApi.getSubscription(subscriptionId as string, signal),
    enabled: Boolean(subscriptionId) && Boolean(user),
    staleTime: 0,
    refetchOnMount: "always",
  });
}
